<template>
  <v-card min-height="500" max-height="600">
    <v-tabs grow centered show-arrows v-model="tab" background-color="primary" dark @change="getDataFromApi">
      <v-tab href="#tab-1"> 1. DÖNEM</v-tab>
      <v-tab href="#tab-2"> 2. DÖNEM</v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="tab" >
      <v-tab-item :value="'tab-1'">
        <v-row v-if="rows.length > 0">
          <v-col cols="12" class="py-0" v-for="item in rows" :key="item.Id">
            <v-sheet outlined>
              <v-card flat>
                <v-card-title :class="$vuetify.breakpoint.mobile ? 'justify-center pb-2':''">{{ item.LessonName }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> Yazılılar </strong>
                      <div>
                        <span>1. {{ item.WrittenExam1 != null ? item.WrittenExam1 : 'Not girilmedi' }}</span> <br>
                        <span> 2. {{ item.WrittenExam2 != null ? item.WrittenExam2 : 'Not girilmedi' }}</span> <br>
                        <span>3. {{ item.WrittenExam3 != null ? item.WrittenExam3 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> Sözlüler </strong>
                      <div>
                        <span>1. {{ item.VerbalExam1 != null ? item.VerbalExam1 : 'Not girilmedi' }}</span> <br>
                        <span>2. {{ item.VerbalExam2 != null ? item.VerbalExam2 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> KKS Sonuç </strong>
                      <div>
                        <span>1. {{ item.PerformanceExam1 != null ? item.PerformanceExam1 : 'Not girilmedi' }}</span> <br>
                        <span>2. {{ item.PerformanceExam2 != null ? item.PerformanceExam2 : 'Not girilmedi' }}</span> <br>
                        <span>3. {{ item.PerformanceExam3 != null ? item.PerformanceExam3 : 'Not girilmedi' }}</span>
                        <span>4. {{ item.PerformanceExam4 != null ? item.PerformanceExam4 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :value="'tab-2'">
        <v-row v-if="rows.length > 0">
          <v-col cols="12" class="py-0" v-for="item in rows" :key="item.Id">
            <v-sheet outlined>
              <v-card flat>
                <v-card-title  :class="$vuetify.breakpoint.mobile ? 'justify-center pb-2':''">{{ item.LessonName }}</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> Yazılılar </strong>
                      <div>
                        <span>1. {{ item.WrittenExam1 != null ? item.WrittenExam1 : 'Not girilmedi' }}</span> <br>
                        <span> 2. {{ item.WrittenExam2 != null ? item.WrittenExam2 : 'Not girilmedi' }}</span> <br>
                        <span>3. {{ item.WrittenExam3 != null ? item.WrittenExam3 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> Sözlüler </strong>
                      <div>
                        <span>1. {{ item.VerbalExam1 != null ? item.VerbalExam1 : 'Not girilmedi' }}</span> <br>
                        <span>2. {{ item.VerbalExam2 != null ? item.VerbalExam2 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                    <v-col cols="12" :class="$vuetify.breakpoint.mobile ? 'd-flex justify-content-between align-items-center' :''">
                      <strong> KKS Sonuç </strong>
                      <div>
                        <span>1. {{ item.PerformanceExam1 != null ? item.PerformanceExam1 : 'Not girilmedi' }}</span> <br>
                        <span>2. {{ item.PerformanceExam2 != null ? item.PerformanceExam2 : 'Not girilmedi' }}</span> <br>
                        <span>3. {{ item.PerformanceExam3 != null ? item.PerformanceExam3 : 'Not girilmedi' }}</span>
                        <span>4. {{ item.PerformanceExam4 != null ? item.PerformanceExam4 : 'Not girilmedi' }}</span>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-sheet>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import ApiService from '@/core/services/api.service'

export default {
  data() {
    return {
      totalRows: 0,
      rows: [],
      loading: true,
      options: {
        sortBy: ['LessonDisplayOrder'],
        sortDesc: [false],
        itemsPerPage: -1,
      },
      filters: {
        period: 1
      },
      tab: null
    }
  },
  mounted() {
    this.getDataFromApi()
  },
  methods: {
    getDataFromApi() {
      this.loading = true

      this.filters.period = this.tab === 'tab-1' ? 1 : 2

      ApiService.setHeader()
      ApiService.post('api/OfficialExam', {
        sortBy: this.options.sortBy,
        descending: this.options.sortDesc,
        rowsPerPage: this.options.itemsPerPage,
        page: 1,
        Query: this.filters
      }).then((data) => {
        this.rows = data.data.Results
        this.totalRows = data.data.TotalNumberOfRecords
        this.loading = false
      }).catch(({response}) => {
        ApiService.showError(response)
        this.loading = false
      })
    }
  }
}
</script>
